import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { services } from "../data/constants";

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileSolOpen, setMobileSolOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const path = location.pathname;
  const isActive = (p) => (p === "/" ? path === "/" : path.startsWith(p));
  const isSolutionsServicesActive =
    path.startsWith("/solutions") || path === "/services";
  const isAboutActive =
    path.startsWith("/about") || path.startsWith("/blog");
  const isServiceDesk = path.startsWith("/service-desk");
  const isCareersActive = path.startsWith("/careers");

  const closeMenu = () => {
    setMenuOpen(false);
    setMobileSolOpen(false);
    setMobileAboutOpen(false);
  };

  return (
    <nav className="navbar-custom">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center w-100">
          <Link to="/" className="navbar-brand d-flex align-items-center text-decoration-none" onClick={closeMenu}>
            <img src={`${process.env.PUBLIC_URL || ""}/img/logo.png`} alt="Emicron" className="navbar-logo me-2" />
          </Link>
          <div className="d-none d-lg-flex align-items-center gap-1 flex-wrap justify-content-end">
            <div className="dropdown dropdown-hover">
              <button className={`nav-link border-0 bg-transparent dropdown-toggle ${isAboutActive ? "active" : ""}`} data-bs-toggle="dropdown" type="button">
                About Us
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/about" className="dropdown-item text-decoration-none" onClick={closeMenu}>
                    <i className="bi bi-building me-2"></i>About Us
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="dropdown-item text-decoration-none" onClick={closeMenu}>
                    <i className="bi bi-journal-richtext me-2"></i>Blog
                  </Link>
                </li>
              </ul>
            </div>
            <div className="dropdown dropdown-hover">
              <button className={`nav-link border-0 bg-transparent dropdown-toggle ${isSolutionsServicesActive ? "active" : ""}`} data-bs-toggle="dropdown" type="button">
                Service/Solution
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/services" className="dropdown-item text-decoration-none fw-semibold" onClick={closeMenu}>
                    <i className="bi bi-grid me-2"></i>Service/Solution
                  </Link>
                </li>
                <li><hr className="dropdown-divider" /></li>
                {services.map((s) => (
                  <li key={s.slug}>
                    <Link to={`/solutions/${s.slug}`} className="dropdown-item text-decoration-none" onClick={closeMenu}>
                      <i className={`${s.icon} me-2`}></i>{s.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <Link to="/partners" className={`nav-link border-0 bg-transparent text-decoration-none ${isActive("/partners") ? "active" : ""}`}>Partners</Link>
            <Link to="/aws-activate" className={`nav-link border-0 bg-transparent text-decoration-none ${isActive("/aws-activate") ? "active" : ""}`}>AWS Activate</Link>
            <Link to="/service-desk" className={`nav-link border-0 bg-transparent text-decoration-none ${isServiceDesk ? "active" : ""}`}>Service Desk</Link>
            <Link to="/careers" className={`nav-link border-0 bg-transparent text-decoration-none ${isCareersActive ? "active" : ""}`}>Careers</Link>
          </div>
          <button className="d-lg-none border-0 bg-transparent fs-4" onClick={() => setMenuOpen(!menuOpen)} type="button" aria-label="Toggle menu">
            <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        {menuOpen && (
          <div className="d-lg-none py-3 border-top mt-2">
            <div className="d-flex flex-column gap-1">
              <button
                type="button"
                className={`nav-link border-0 bg-transparent text-start text-decoration-none d-flex align-items-center justify-content-between ${isAboutActive ? "active" : ""}`}
                onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
              >
                About Us
                <i className={`bi bi-chevron-${mobileAboutOpen ? "up" : "down"}`}></i>
              </button>
              {mobileAboutOpen && (
                <div className="ps-3 ms-1 border-start border-secondary border-opacity-25 d-flex flex-column gap-1">
                  <Link to="/about" className="nav-link border-0 bg-transparent text-start text-decoration-none py-1 small" onClick={closeMenu}>About Us</Link>
                  <Link to="/blog" className="nav-link border-0 bg-transparent text-start text-decoration-none py-1 small" onClick={closeMenu}>Blog</Link>
                </div>
              )}
              <button
                type="button"
                className={`nav-link border-0 bg-transparent text-start text-decoration-none d-flex align-items-center justify-content-between ${isSolutionsServicesActive ? "active" : ""}`}
                onClick={() => setMobileSolOpen(!mobileSolOpen)}
              >
                Service/Solution
                <i className={`bi bi-chevron-${mobileSolOpen ? "up" : "down"}`}></i>
              </button>
              {mobileSolOpen && (
                <div className="ps-3 ms-1 border-start border-secondary border-opacity-25 d-flex flex-column gap-1">
                  <Link to="/services" className="nav-link border-0 bg-transparent text-start text-decoration-none py-1 small fw-semibold" onClick={closeMenu}>
                    Service/Solution
                  </Link>
                  {services.map((s) => (
                    <Link key={s.slug} to={`/solutions/${s.slug}`} className="nav-link border-0 bg-transparent text-start text-decoration-none py-1 small" onClick={closeMenu}>
                      {s.title}
                    </Link>
                  ))}
                </div>
              )}
              <Link to="/partners" className="nav-link border-0 bg-transparent text-start text-decoration-none" onClick={closeMenu}>Partners</Link>
              <Link to="/aws-activate" className="nav-link border-0 bg-transparent text-start text-decoration-none" onClick={closeMenu}>AWS Activate</Link>
              <Link to="/service-desk" className="nav-link border-0 bg-transparent text-start text-decoration-none" onClick={closeMenu}>Service Desk</Link>
              <Link to="/careers" className={`nav-link border-0 bg-transparent text-start text-decoration-none ${isCareersActive ? "active" : ""}`} onClick={closeMenu}>Careers</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
